<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="检查报告"
        left-arrow
        left-text="返回"
        :fixed="true"
        @click-left="onClickLeft"
      />
    </div>
    <div class="head">
      <div class="title_head">
        <div class="title_head_name">{{ name }}</div>
      </div>
      <div class="head_row">
        <span class="geary">流水号：</span>{{ patientId }}
      </div>
    </div>
    <div class="body">
          <div class="cholseDate">
      <div
        class="dateitem"
        :value="begindate"
        @click="showCalendar['begindate'] = true"
      >
        {{ begindate }}
      </div>
      <div class="dateitem_-">~</div>
      <div
        class="dateitem"
        :value="enddate"
        @click="showCalendar['enddate'] = true"
      >
        {{ enddate }}
      </div>
      <van-calendar
        color="#5b8df6"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="showCalendar['begindate']"
        @confirm="(value) => onConfirm(value, 'begindate')"
      />
      <van-calendar
        color="#5b8df6"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="showCalendar['enddate']"
        @confirm="(value) => onConfirm(value, 'enddate')"
      />
    </div>
      <div
        class="listcard"
        v-if="emptyflag"
        v-for="(item, index) in pacssampleList"
        :key="index"
        @click="reportDetialClick(item)"
      >
        <div class="listcard_title line">
          <div class="listcard_title_a">状态</div>
          <div class="listcard_title_b color">可查看</div>
        </div>
        <div class="listcard_row">
          <div class="listcard_row_a">项目名称</div>
          <div class="listcard_row_b">{{ item.projectName }}</div>
        </div>
        <div class="listcard_row">
          <div class="listcard_row_a">申请科室：</div>
          <div class="listcard_row_b">{{ item.applyDeptName }}</div>
        </div>
        <div class="listcard_row">
          <div class="listcard_row_a">检查类别：</div>
          <div class="listcard_row_b" style="color: #f40">
            {{ item.categoryName }}
          </div>
        </div>
        <div class="listcard_row">
          <div class="listcard_row_a">报告时间：</div>
          <div class="listcard_row_b" style="color: #f40">
            {{ item.reportDate }}
          </div>
        </div>
      </div>
      <div v-if="!emptyflag">
        <van-empty
          image="https://account.kmmds.top/datainfo_pic/error.png"
          description="暂无报告单"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import setOptions from "@/mixins/setOption";
export default {
  name: "hospitalExamineReport",
  mixins: [setOptions],
  data() {
    return {
        showCalendar: {
        begindate: false,
        enddate: false,
      },
       begindate: new Date(),
      enddate: new Date(),
       minDate: new Date(2020, 0, 1),
      maxDate: new Date(2040, 0, 1),
      pacssampleList: [],
      price: null,
      clientId: "",
      name: "",
      patientId: "暂无",
      emptyflag: true,
    };
  },
  components: {
    Nav,
  },
  created() {
    this.clientId = this.$route.query.clientId;
    this.name = this.$route.query.name;
       this.begindate = this.getLmDay(this.begindate);
       this.enddate = this.getyDay(this.enddate);
    this.getpacssample()
  },
  methods: {
     getyDay(date) {
      date.setTime(date.getTime());
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //获取上个月
    getLmDay(date) {
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * 30);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
     onConfirm(value, type) {
      //  console.log(new Date(value))
      this[type] = this.formatDate(new Date(value));
      this.showCalendar[type] = false;
      this.getpacssample();
    },
     formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onClickLeft() {
      this.$router.push({
        path: "/reportList",
        query: {
          clientId: this.clientId,
          name: this.name,
        },
      });
    },
    async getpacssample() {
      // console.log(this.method_depy_type)
      try {
        let reqData = {
          medCardNo: this.clientId,
          begDate: this.begindate,
          endDate: this.enddate,
        };
        this.$showLoad();
        let url = "/report/QueryPacsReportCard";
        // console.log(R_data)
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reqData,
          (data) => {
            this.$hideLoad();
            console.log(data)
            
            if(data.data.data.data.length==0){
                this.emptyflag=false
            }else{
               this.pacssampleList=data.data.data.data
               this.emptyflag=true
            }
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    reportDetialClick(item) {
    //   console.log("----->", item);
      this.$router.push({
        path: "/jinfengPacsdetal",
        query: {
             item,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.color {
  color: #2ed573 !important;
}

.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  background-color: #eee;
  .nav {
    height: 6vh;
    .top {
      height: 6vh;
    }
  }
  .head {
    width: 100%;
    background-color: #5b8df6;
    height: 15vh;
    display: flex;
    flex-direction: column;
    color: white;
    padding: 15px;
    .title_head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 6vh;
      .title_head_name {
        font-size: 25px;
      }
      .title_head_age {
        font-size: 14px;
      }
    }
    .head_row {
      font-size: 14px;
      line-height: 4vh;
      color: #ffffff;
    }
  }
  .body {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 94vh;
    overflow: scroll;
      .cholseDate {
    widows: 90%;
    display: flex;
    margin: 0px auto;
    margin-top: 2vh;
    margin-bottom: 2vh;
    .dateitem_- {
      margin-left: 20px;
      color: #95a5a6;
    }
    .dateitem {
      margin-left: 20px;
      color: #95a5a6;
      border-bottom: 1px solid #95a5a6;
    }
  }
    .listcard {
      display: flex;
      flex-direction: column;
      background-color: white;
      width: 100%;
      margin: 0px auto;
      margin-bottom: 8px;
    }
    .listcard_title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 24px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_title_a {
        font-size: 16px;
      }
      .listcard_title_b {
        font-size: 14px;
        color: #999;
      }
    }
    .listcard_row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 15px;
      width: 95%;

      padding: 10px;
      margin: 0px auto;
      .listcard_row_a {
        font-size: 14px;
        color: #999;
      }
      .listcard_row_b {
        font-size: 14px;
      }
    }
    .listcard_money {
      line-height: 35px;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 95%;
      text-align: end;
      .moneycolor {
        color: #5b8df6;
        font-weight: bolder;
        font-size: 18px;
      }
    }
  }
}
</style>
